import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import FormularioOS1 from './Components/FormularioOS1';
import FormularioTur1 from './Components/FormularioTur';
import Vista from './Components/Vista';
import Done from './Components/Done';
import DoneApp from './Components/DoneApp';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<FormularioOS1/>}></Route>
          <Route path='/turismo' element={<FormularioTur1/>}></Route>
          <Route path='/vista' element={<Vista/>}></Route>
          <Route path='/done' element={<Done/>}></Route>
          <Route path='/doneapp' element={<DoneApp/>}></Route>

        </Routes>
      </BrowserRouter>
    
      </div>
  );
}

export default App;
